import { DocumentUploadResponse } from '../../types/chatTypes'
import { axiosClient } from '../axiosClient'

export const documentFunctions = {
  uploadDocument: async (
    file: File,
  ): Promise<DocumentUploadResponse> => {
    const formData = new FormData()
    formData.append('file', file)

    return await axiosClient.post('api/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  deleteDocument: async (
    documentId: string,
  ): Promise<void> => {
    await axiosClient.delete<void>(`api/documents/${documentId}`)
  },
}
